document.addEventListener('DOMContentLoaded', function() {
    function setDefaultCountry() {
      const countryNameInput = document.getElementById('country-name');
      const countryFieldInput = document.getElementById('country-field');

      if (countryNameInput && countryFieldInput && !countryNameInput.value.trim()) {
        countryNameInput.value = 'United States';
        countryFieldInput.value = 'US';

        countryNameInput.dispatchEvent(new Event('input', { bubbles: true }));
        countryNameInput.dispatchEvent(new Event('change', { bubbles: true }));
        countryFieldInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    setDefaultCountry();

    const observer = new MutationObserver(function() {
      const countryNameInput = document.getElementById('country-name');
      if (countryNameInput && !countryNameInput.value.trim()) {
        setDefaultCountry();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });